import Layout from '../../views/layouts/index'
const taskRouter = {
  path: '/',
  component: Layout,
  redirect: '/task',
  alwaysShow: true,
  name: 'task',
  children: [
    {
      path: 'task',
      component: () => import('../../views/task/index'),
      name: 'task_index',
    },
    {
      path: 'task/detail',
      component: () => import('../../components/order/detail'),
      name: 'task_detail',
      meta:{activeMenu:'/task'}
    }
  ]
}

export default taskRouter



// WEBPACK FOOTER //
// ./src/router/modules/task.js